
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, User } from 'lucide-react';
import ThemeToggle from '@/components/common/ThemeToggle';

interface DashboardHeaderProps {
  psychologist: { name: string; email: string } | null;
  onRefresh: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  psychologist,
  onRefresh,
}) => {
  return (
    <header className="bg-card border-b border-border">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-primary/10 p-2 rounded-lg">
              <User className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h1 className="text-xl font-semibold text-foreground">
                Dashboard do Psicólogo
              </h1>
              {psychologist && (
                <p className="text-sm text-muted-foreground">
                  Bem-vindo, {psychologist.name}
                </p>
              )}
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <ThemeToggle />
            <Button variant="outline" size="sm" onClick={onRefresh}>
              <RefreshCw className="h-4 w-4 mr-2" />
              Atualizar
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
